module.exports = __webpack_public_path__ + "static/cely_rose_grossesse_5-a7afa3de9f66fd1e58ee146cae245822.jpg";